import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { ChatCenterComponent } from './pages/support/chat-center/chat-center.component';
import { CustomerVaultComponent } from './pages/merchant-account/customer-vault/customer-vault.component';
import { MerchantsPageComponent } from './pages/merchants/merchants-page.component';
import { ReportingComponent } from './pages/reporting/reporting.component';
import { SigninComponent } from './pages/signin/signin.component';
import { SignoutComponent } from './pages/signout/signout.component';
import { StatementsComponent } from './pages/merchant-account/merchant-account-statements/statements.component';
import { SupportComponent } from './pages/support/support.component';
import { TerminalComponent } from './pages/terminal/terminal.component';
import { RecentTransactionsComponent } from './pages/merchant-account/transactions/merchant-transactions-page.component';
import { AdminComponent } from './pages/admin/admin.component';
import { RestrictedComponent } from './pages/error/restricted/restricted.component';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
import { UsersPageComponent } from './pages/users-page/users-page.component';
import { CustomerAccountComponent } from './pages/merchant-account/customer-account/customer-account.component';
import { TransactionDetailsPageComponent } from './pages/transaction-details-page/transaction-details-page.component';
import { ReroutePageComponent } from './pages/reroute-page/reroute-page.component';
import { SuggestionBoxPageComponent } from './pages/suggestion-box-page/suggestion-box-page.component';
import { StyleGuidePageComponent } from './pages/admin/style-guide/style-guide-page/style-guide-page.component';
import { LeadPageComponent } from './pages/lead-page/lead-page.component';
import { LeadsPageComponent } from './pages/leads-page/leads-page.component';
import { StylePageComponent } from './pages/style-page/style-page.component';
import { ResidualsDashboardPageComponent } from './pages/residuals/residuals-dashboard-page/residuals-dashboard-page.component';
import { MyAccountComponent } from './pages/my-account/my-account.component';
import { BusinessDetailsComponent } from './pages/merchant-account/business-details/business-details.component';
import { CronPageComponent } from './pages/admin/cron-page/cron-page.component';
import { TestingComponent } from './pages/admin/testing/testing.component';
import { ManageInvoiceComponent } from './pages/manage-invoice/manage-invoice.component';
import { CreateInvoiceComponent } from './pages/create-invoice/create-invoice.component';
import { CatalogsPageComponent } from './pages/catalogs-page/catalogs-page.component';
import { PayableInvoiceComponent } from './pages/payable-invoice/payable-invoice.component';
import { InvoiceSettingsComponent } from './pages/invoice-settings/invoice-settings.component';
import { BootstrapSessionComponent } from './pages/bootstrap-session/bootstrap-session.component';
import { MasterLayoutComponent } from './layouts/master-layout/master-layout.component';
import { SidenavLayout } from './layouts/sidenav-layout/sidenav-layout';
import { BusinessHubLayout } from './layouts/business-hub-layout/business-hub-layout';
import { MerchantLayoutComponent } from './layouts/merchant-layout/merchant-layout.component';
import { MerchantOrdersPageComponent } from './pages/merchant-account/orders/merchant-orders-page.component';
import { BusinessHubPageComponent } from './pages/merchant-account/business-hub-page.component';
import { ProfilePage } from './pages/my-account/profile-page/profile-page';
import { ExternalInvoiceComponent } from './pages/external-invoice/external-invoice.component';
import { MerchantTransactionGraphsComponent } from './pages/merchant-graphs/merchant-transaction-graphs.component';

const routes: Routes = [
  { path: '', redirectTo: '/dashboard', pathMatch: 'full' },
  { path: 'payable-invoice', component: PayableInvoiceComponent },
  { path: 'campfire/:merchantName', component: ExternalInvoiceComponent },

  // Master layout, no secondary navigation
  {path: '', component: MasterLayoutComponent, children: [
    { path: 'lead', component: LeadPageComponent },
    { path: 'leads', component: LeadsPageComponent },
    { path: 'reporting', component: ReportingComponent },
    { path: 'restricted', component: RestrictedComponent },
    { path: 'signin', component: SigninComponent },
    { path: 'signout', component: SignoutComponent },
    { path: 'style', component: StylePageComponent },
    { path: 'style/internal', component: StyleGuidePageComponent },
    { path: 'suggestions', component: SuggestionBoxPageComponent },
    { path: 'support', component: SupportComponent },
    { path: 'support/chat-center', component: ChatCenterComponent },
    { path: 'residuals', component: ResidualsDashboardPageComponent },
    { path: 'admin/cron', component: CronPageComponent },
    { path: 'admin/testing', component: TestingComponent },
    { path: 'profile', component: ProfilePage },
]},
  // Master layout, secondary navigation (Dashboard)
  {
    path: '', component: MasterLayoutComponent, children: [
        { path: '', component: SidenavLayout, children: [
          { path: 'graphs', component: MerchantTransactionGraphsComponent },
          { path: 'admin', component: AdminComponent },
          { path: 'merchants', component: MerchantsPageComponent }, //merchants/merchants.component
          { path: 'dashboard', component: DashboardComponent },
          { path: 'transactions', component: RecentTransactionsComponent },
          { path: 'users', component: UsersPageComponent },
        ]
      }
    ]
  },
   //Merchant pages, no secondary navigation
  //  {
  //    path: '', component: MasterLayoutComponent,
  //    children: [
  //      { path: '', outlet: 'sticky', component: MerchantLayoutComponent },
  //    ]
  //  },
  
  // Business Hub, secondary navigation
  {
    path: '', component: MasterLayoutComponent, children: [
      { path: '', outlet: 'sticky', component: MerchantLayoutComponent },
      { path: '', component: BusinessHubLayout, children: [
        { path: 'merchant/hub', component: BusinessHubPageComponent },
        { path: 'merchant/account', component: BusinessDetailsComponent }, // merchants/business/business-details/business-details.component
        { path: 'merchant/transactions', component: RecentTransactionsComponent },
        { path: 'merchant/orders', component: MerchantOrdersPageComponent },
        { path: 'merchant/customers', component: CustomerVaultComponent },
        { path: 'merchant/invoices', component: ManageInvoiceComponent },
        { path: 'merchant/invoices/settings', component: InvoiceSettingsComponent },
        { path: 'merchant/invoices/create', component: CreateInvoiceComponent },
        { path: 'merchant/catalog', component: CatalogsPageComponent },
        { path: 'merchant/statements', component: StatementsComponent },
        { path: 'merchant/terminal', component: TerminalComponent },
        { path: 'merchants/terminal/tid/:tid/v/:v', component: TerminalComponent },
        { path: 'merchant', component: MerchantTransactionGraphsComponent }, // ???
        { path: 'create-invoice', component: CreateInvoiceComponent },
        { path: 'invoice-settings', component: InvoiceSettingsComponent },
          ]},
    ]
  },

  { path: 'transaction', component: TransactionDetailsPageComponent },

  // This is only linked from the site search, which isn't currently used.
  { path: 'customer-account', component: CustomerAccountComponent }, // merchant-account/customer-account/customer-account.component

  // This is basically just redirecting to the merchant business info page.
  // Should this become the landing page for Business Hub?
  { path: 'my-account', component: MyAccountComponent },

  { path: 'reroute', component: ReroutePageComponent },
  {path: 'bootstrap', component: BootstrapSessionComponent},

];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { scrollPositionRestoration: 'enabled' }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {
  constructor() {}
}
